import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getAllPositions } from 'api/positions/getAllPositions'
import { positionsKeys } from './keys'

export const usePositionsQuery = (
  request: Parameters<typeof getAllPositions>[0]
) => {
  return useQuery({
    queryKey: positionsKeys.list(Object.values(request)),
    queryFn: () => getAllPositions(request),
    placeholderData: keepPreviousData,
  })
}
